/* global BigInt */

const MAX_BIGINT_UNSIGNED = 18446744073709551615n
const MAX_SEQUENCE = 999

let lastTimestamp = 0
let sequence = 0

const ORIGIN = {
  cusco: 0,
  portal: 1,
}

function createUniqueId(origin = 'cusco') {
  if (!(origin in ORIGIN)) {
    throw new Error(`Invalid ID origin: ${origin}`)
  }

  const timestamp = Date.now()

  if (timestamp === lastTimestamp) {
    sequence++
  } else {
    lastTimestamp = timestamp
    sequence = 0
  }

  if (sequence > MAX_SEQUENCE) {
    throw new Error(
      'Unable to generate unique ID: sequence limit reached'
    )
  }

  const id = BigInt(
    `${timestamp}${String(sequence).padStart(3, '0')}${ORIGIN[origin]}`
  )

  if (id > MAX_BIGINT_UNSIGNED) {
    throw new Error(
      'Generated ID exceeds BIGINT UNSIGNED range'
    )
  }

  console.log('Generated ID:', id)

  return id.toString()
}

export { createUniqueId }
export default createUniqueId